import { useMemo } from 'react';
import {
  getEditionLabelFragment,
  getProductLabelFragment
} from '../utility/sign-up-form-header';
import { ProductKeysType } from '../../../../model';
import { messages } from './messages';

export interface UseFormHeaderLabelsParams {
  edition: string;
  labels: {
    [key: string]: string;
  };
  productKeys: ProductKeysType[];
  skip?: boolean;
  useBundleHeaderOverride?: boolean;
}

export const useFormHeaderLabels = ({
  labels,
  edition,
  productKeys,
  skip,
  useBundleHeaderOverride
}: UseFormHeaderLabelsParams) => {
  const { heading, subheading } = useMemo(() => {
    if (skip) {
      return {
        heading: messages.heading,
        subheading: messages.subheading
      };
    }
    const editionLabelFragment = getEditionLabelFragment(edition);
    const productLabelFragment = getProductLabelFragment(productKeys);
    const bundleHeaderOverrideOrEmpty = useBundleHeaderOverride
      ? 'BundlesLayout'
      : '';

    const headingLabel = `${messages.heading.id}${editionLabelFragment}${productLabelFragment}${bundleHeaderOverrideOrEmpty}`;
    const subheadingLabel = `${messages.subheading.id}${editionLabelFragment}${productLabelFragment}${bundleHeaderOverrideOrEmpty}`;
    return {
      heading: {
        id: headingLabel,
        defaultMessage: labels[headingLabel] || messages.heading.defaultMessage
      },
      subheading: {
        id: subheadingLabel,
        defaultMessage:
          labels[subheadingLabel] || messages.subheading.defaultMessage
      }
    };
  }, []);

  return { heading, subheading };
};
